import { render, staticRenderFns } from "./EmployeeTabs.vue?vue&type=template&id=141ca6b0&scoped=true&"
import script from "./EmployeeTabs.vue?vue&type=script&lang=js&"
export * from "./EmployeeTabs.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeTabs.vue?vue&type=style&index=0&id=141ca6b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ca6b0",
  null
  
)

export default component.exports